import { useEffect, useState } from "react";
import { getPublications } from "../../API/getters";
import PublicationCard from "../../Components/Graduado/PublicationCard";
import NovaPublicacao from "../../Components/Graduado/NovaPublicacao";
import { useNavigate } from "react-router-dom";
// import AindaSem from "../../Components/Graduado/AindaSem";
import { Loader2, FileText, PlusCircle, RefreshCw } from 'lucide-react';

export default function Feed() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  async function fetchData() {
    try {
      setLoading(true);
      setError(null);
      const result = await getPublications();
      setPosts(result);
      console.log(result);
    } catch (err) {
      setError('Erro ao carregar publicações');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="w-full py-6">
    
      {/* Nova Publicação Component */}
      <div className="mb-8">
        <NovaPublicacao />
      </div>

      {/* Loader */}
      {loading && (
        <div className="flex flex-col items-center py-16">
          <Loader2 className="w-8 h-8 text-emerald-500 animate-spin mb-3" />
          <span className="text-gray-400 text-sm">A carregar publicações...</span>
        </div>
      )}

      {/* Error */}
      {!loading && error && (
        <div className="bg-red-50/50 rounded-xl p-6 border border-red-100 text-center">
          <div className="text-red-500 text-sm mb-2">{error}</div>
          <button 
            onClick={fetchData}
            className="text-emerald-600 text-sm hover:text-emerald-700 inline-flex items-center gap-1"
          >
            <RefreshCw size={12} />
            Tentar novamente
          </button>
        </div>
      )}

      {/* Lista de publicações */}
      {!loading && !error && posts.length > 0 && (
        <div className="space-y-6">
          {posts.map((post) => (
            <PublicationCard
              key={post.uuid}
              text={post.description}
              image={post.image}
              title={post.title}
              id={post.uuid}
              authorFormation={post.course_name}
              authorName={post.user_name}
              likeCount={post.likes_count}
            />
          ))}
        </div>
      )}

      {/* Estado vazio amigável */}
      {!loading && !error && posts.length === 0 && (
        <div className="bg-gray-50/50 rounded-xl p-12 text-center border border-gray-100">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 rounded-full bg-emerald-50 flex items-center justify-center">
              <FileText className="w-8 h-8 text-emerald-500" />
            </div>
          </div>
          <h3 className="text-lg font-light text-gray-700 mb-2">Sem publicações</h3>
          <p className="text-gray-400 text-sm mb-6">
            Seja o primeiro a compartilhar algo com a comunidade
          </p>
          <button 
            onClick={() => navigate('/publicar')}
            className="inline-flex items-center gap-2 bg-emerald-600 text-white px-5 py-2 text-sm font-medium rounded-lg hover:bg-emerald-700 transition-colors shadow-sm"
          >
            <PlusCircle size={16} />
            Criar Publicação
          </button>
        </div>
      )}
    </div>
  );
}